import type { DialogsContainerProps } from '@confluence/dialogs/entry-points/DialogsStateContainer.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { UseTemplateEditorLabelsType } from '@confluence/template-utils/entry-points/useTemplateEditorLabels.ts';
import type { EditLabelDialogComponentProps } from './EditLabelDialogComponent.tsx';

export const EditLabelDialogLoader: LoadableType<
	EditLabelDialogComponentProps & DialogsContainerProps & UseTemplateEditorLabelsType
> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EditLabelDialogComponent" */ './EditLabelDialogComponent.tsx'
			)
		).EditLabelDialogComponent,
});
